














import { Component, Vue } from 'vue-property-decorator';
import api_client from '../lib/api_client';

@Component
export default class Home extends Vue {
  public form = {
    email: '',
    password: '',
  };

  public async login() {
    const response = await api_client.post('/sessions', {
      login: this.form,
    });
    this.$store.commit('setToken', response.data.token);
    this.$router.push({ name: 'profile' });
  }
}
